import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchRole } from "./api";
import type { Role } from "./api";

// Detail одной роли (default + effective + override).
// `enabled` зависит от выбранной роли — пока роль не выбрана (null),
// запрос не идёт.
export function useRoleDetail(
  roleName: string | null,
): UseQueryResult<Role, Error> {
  return useOrgScopedQuery<Role>({
    key: ["agent-roles", "detail", roleName],
    queryFn: () => fetchRole(roleName ?? ""),
    enabled: roleName !== null,
    retry: false,
  });
}
